export default `
	field
	updated_at
	title
	description
	
	language {
		code
	}
`;
